<template>
	<div>
		<h2>{{ $t('monte.reservation.reservation_semence') }}</h2>
		<div class="box">
			<ReservationMonte
				:supplier_id="parseInt(tiers_id)"
				:available_tiers="all_tiers"
				:available_mares="juments"
				:available_centre_stockage="available_centre_stockage"
				:show_title="false"
			/>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Contract from '@/mixins/Contract.js'
	import TiersMixin from '@/mixins/Tiers.js'
	import MonteReservationOrder from "@/mixins/MonteReservationOrder.js"

	export default {
		name: "MonteReservation",
		mixins: [Contract, TiersMixin, MonteReservationOrder],
		props: ['tiers_id'],
		data() {
			return {
				all_tiers: [],
				juments: [],
				available_centre_stockage: []
			}
		},
		mounted() {
			this.init_component()
		},
		methods: {
			async init_component() {
				this.all_tiers  = await this.loadTiers()
				this.juments    = await this.loadJuments()
				this.available_centre_stockage = await this.loadCentreStockage()
			}
		},
		components: {
			ReservationMonte : () => import('@/components/Contract/Reservation/ReservationList')
		}
	}
</script>
